import OrderCargoOrderNodeExclusionResponse from "../../../../api/raily/order/cargo-order/node-exclusion/order-cargo-order-node-exclusion.response";
import OrderCargoOrderNodeExclusion from "./order-cargo-order-node-exclusion";

const create = (
  response: OrderCargoOrderNodeExclusionResponse,
): OrderCargoOrderNodeExclusion => {
  return {
    excludeInside: response.data.excludeInside,
  };
};

const orderCargoOrderNodeExclusionFactory = {
  create,
};

export default orderCargoOrderNodeExclusionFactory;
